import React, { useContext } from "react";
import { useLocation } from "react-router-dom";
import { HubContext } from "Redux/Context/context";
import RegisteredListSubMenu from "./Registered";
import { ROUTES_PATH } from "Chore/Constants";

const SubMenuKeyMap = {
  "pending-feedback-activity": "PendingFeedback",
  "completed-activity": "Closed",
  "registered-activity": "Registered",
};
const ActivityListSubMenu = ({ onChange }) => {
  const { myActivitiesState } = useContext(HubContext);
  const location = useLocation();
  return (
    location.pathname === ROUTES_PATH.MY_ACTIVITY &&
    myActivitiesState.module === "REGISTERED" && (
      <RegisteredListSubMenu
        onChange={(e) => {
          onChange(SubMenuKeyMap[e.detail]);
        }}
      ></RegisteredListSubMenu>
    )
  );
};

export default ActivityListSubMenu;
